<template>
  <div>
    <BaseLoader 
      v-if="$statsigState.loading"
      size="xl"
    />
    <KiosksEnhanced v-else-if="$statsigState.initialized && isFeatureEnabled"/>
    <Kiosks v-else/>
  </div>
</template>

<script>
import KiosksEnhanced from './KiosksNew.vue';
import Kiosks from './Kiosks.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { Feature_Flags } from '@/enums/globals';

export default {
  name: 'KiosksFeatureFlagSwitcher',
  
  components: {
    KiosksEnhanced,
    Kiosks,
    BaseLoader
  },

  computed: {
    isFeatureEnabled() {
      const { isFeatureEnabled } = useFeatureFlags()
      return isFeatureEnabled(Feature_Flags.PORTAL_KIOSKS_REVAMP);
    }
  }
}
</script>